import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('component.auth.language');
import { OnInit, ElementRef, ViewChild, HostListener } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-component-auth-language',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/component.auth.language/view.scss */
:host {
  position: fixed;
  top: max(16px, env(safe-area-inset-top));
  right: max(24px, env(safe-area-inset-right));
  z-index: 20;
  display: block;
  --language-surface: #fff;
  --language-trigger: rgba(255, 255, 255, .88);
  --language-border: #e2e8f0;
  --language-text: #263449;
  --language-muted: #64748b;
  --language-hover: #f6f8fc;
  --language-active: #eef2ff;
  --language-active-end: #f8faff;
  --language-active-border: #c7d2fe;
  --language-accent: #4f46e5;
  --language-ring: #6366f1;
  --language-icon: #eef2ff;
  --language-shadow: 0 16px 48px rgba(30, 41, 59, .14), 0 3px 10px rgba(30, 41, 59, .05);
}

.auth-language-control {
  position: relative;
}

.auth-language-select {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  min-width: 130px;
  min-height: 48px;
  padding: 7px 16px 7px 8px;
  border: 1px solid var(--language-border);
  border-radius: 16px;
  background: var(--language-trigger);
  backdrop-filter: blur(12px);
  color: var(--language-text);
  box-shadow: 0 3px 12px rgba(30, 41, 59, 0.06), inset 0 1px 0 rgba(255, 255, 255, 0.08);
  font-size: 14px;
  font-weight: 600;
  line-height: 1.4;
  cursor: pointer;
  transition: border-color 0.15s ease, box-shadow 0.15s ease, background-color 0.15s ease;
}
.auth-language-select:hover, .auth-language-select.is-open {
  border-color: var(--language-active-border);
  background: var(--language-surface);
  box-shadow: 0 4px 16px rgba(30, 41, 59, 0.1), 0 0 0 3px var(--language-icon);
}
.auth-language-select:focus-visible {
  outline: 2px solid var(--language-ring);
  outline-offset: 3px;
}

.language-trigger-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  flex-shrink: 0;
  border-radius: 10px;
  background: var(--language-icon);
  color: var(--language-accent);
  font-size: 16px;
}

.auth-language-menu {
  position: absolute;
  top: calc(100% + 12px);
  right: 0;
  width: 248px;
  max-width: calc(100vw - 48px);
  padding: 10px;
  border: 1px solid var(--language-border);
  border-radius: 20px;
  background: var(--language-surface);
  color: var(--language-text);
  box-shadow: var(--language-shadow);
  animation: language-appear 0.12s ease-out;
}

.language-menu-heading {
  display: flex;
  flex-direction: column;
  gap: 5px;
  margin: 0 4px 10px;
  padding: 8px 6px 14px;
  border-bottom: 1px solid var(--language-border);
  font-size: 14px;
  font-weight: 600;
  line-height: 1.4;
}

.language-eyebrow {
  color: var(--language-muted);
  font-size: 9px;
  font-weight: 600;
  letter-spacing: 0.16em;
}

.language-option {
  display: flex;
  align-items: center;
  gap: 12px;
  width: 100%;
  min-height: 64px;
  padding: 11px;
  border: 1px solid transparent;
  border-radius: 13px;
  background: transparent;
  color: var(--language-text);
  text-align: left;
  font-size: 14px;
  font-weight: 500;
  line-height: 1.4;
  cursor: pointer;
  transition: background-color 0.15s ease, border-color 0.15s ease;
}
.language-option + .language-option {
  margin-top: 6px;
}
.language-option:hover {
  background: var(--language-hover);
}
.language-option.is-selected {
  background: linear-gradient(115deg, var(--language-active), var(--language-active-end));
  border-color: var(--language-active-border);
  color: var(--language-accent);
  font-weight: 600;
}
.language-option:focus-visible {
  outline: 2px solid var(--language-ring);
  outline-offset: -2px;
}
.language-option .fa-check {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 20px;
  height: 20px;
  margin-left: auto;
  border-radius: 50%;
  background: #4f46e5;
  color: #fff;
  font-size: 10px;
}

.language-code {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 36px;
  height: 36px;
  border: 1px solid var(--language-border);
  border-radius: 10px;
  background: var(--language-surface);
  color: var(--language-muted);
  font-size: 17px;
  font-weight: 600;
}

.is-selected .language-code {
  color: var(--language-accent);
  border-color: var(--language-active-border);
}

.language-option-label {
  display: flex;
  flex-direction: column;
  gap: 3px;
}

.language-native-name {
  color: var(--language-muted);
  font-size: 11px;
  font-weight: 400;
}

:host-context(.dark) {
  --language-surface: #1e293b;
  --language-trigger: rgba(30, 41, 59, .94);
  --language-border: #3a485e;
  --language-text: #f1f5f9;
  --language-muted: #a5b2c6;
  --language-hover: #273449;
  --language-active: #333d64;
  --language-active-end: #29334e;
  --language-active-border: #606aa3;
  --language-accent: #d0d5ff;
  --language-ring: #a5b4fc;
  --language-icon: #323c5d;
  --language-shadow: 0 18px 48px rgba(5, 12, 28, .25), 0 3px 10px rgba(5, 12, 28, .12);
}

@keyframes language-appear {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
@media (prefers-reduced-motion: reduce) {
  .auth-language-menu {
    animation: none;
  }
  .auth-language-select, .language-option {
    transition: none;
  }
}`],
})
export class ComponentAuthLanguageComponent implements OnInit {
    @ViewChild('languageTrigger') public languageTrigger: ElementRef;
    public menuOpen = false;
    private tabbingFromMenu = false;

    constructor(@Inject( Service) public service: Service,@Inject( ElementRef)  private element: ElementRef) { }

    public async ngOnInit() {
        await this.service.init();
        await this.service.render();
    }

    public async toggleMenu() {
        if (this.menuOpen) return this.closeMenu(true);
        await this.openMenu(this.service.i18n.isKo ? 0 : 1);
    }

    public async openMenu(index: number) {
        this.menuOpen = true;
        await this.service.render();
        this.focusOption(index);
    }

    private focusOption(index: number) {
        const options = this.element.nativeElement.querySelectorAll('[role="menuitemradio"]');
        options[index]?.focus();
    }

    public async closeMenu(restoreFocus = false) {
        if (!this.menuOpen) return;
        this.menuOpen = false;
        await this.service.render();
        if (restoreFocus) this.languageTrigger.nativeElement.focus();
    }

    public async setLanguage(language: 'ko' | 'en') {
        this.service.i18n.set(language);
        await this.closeMenu(true);
    }

    public onTriggerKeydown(event: KeyboardEvent) {
        if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
            event.preventDefault();
            this.openMenu(event.key === 'ArrowDown' ? 0 : 1);
        } else if (event.key === 'Escape') {
            event.preventDefault();
            this.closeMenu(true);
        }
    }

    public onMenuKeydown(event: KeyboardEvent) {
        const options = Array.from(this.element.nativeElement.querySelectorAll('[role="menuitemradio"]'));
        const index = options.indexOf(document.activeElement);
        let next: number;
        if (event.key === 'ArrowDown') next = (index + 1) % options.length;
        else if (event.key === 'ArrowUp') next = (index + options.length - 1) % options.length;
        else if (event.key === 'Home') next = 0;
        else if (event.key === 'End') next = options.length - 1;
        else if (event.key === 'Escape') {
            event.preventDefault();
            event.stopPropagation();
            this.closeMenu(true);
            return;
        } else {
            if (event.key === 'Tab') this.tabbingFromMenu = true;
            return; // Enter/Space activate the button; Tab moves focus normally.
        }
        event.preventDefault();
        this.focusOption(next);
    }

    @HostListener('document:pointerdown', ['$event'])
    public onOutsidePointer(event: PointerEvent) {
        if (!this.element.nativeElement.contains(event.target)) this.closeMenu();
    }

    @HostListener('focusout', ['$event'])
    public onFocusOut(event: FocusEvent) {
        if (!this.element.nativeElement.contains(event.relatedTarget) ||
            (this.tabbingFromMenu && event.relatedTarget === this.languageTrigger?.nativeElement)) this.closeMenu();
        this.tabbingFromMenu = false;
    }
}

export default ComponentAuthLanguageComponent;